<template>
  <div class="control_point_request">
    <div class="control_point_request-overlay" @click="switchControlPointRequestModal"></div>
    <div class="control_point_request-card">
      <div class="card-body">
        <div class="body-block">
          <div class="card-tags">
            <div v-if="isCriticalControlPointClosureRequest"
              class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--primary ccs-tag--no_action">
              Заявка на закрытие ККТ
            </div>
            <div v-if="localControlPointRequest.status === 'approved'"
              class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--success ccs-tag--no_action">
              Заявка одобрена
            </div>
            <div v-if="localControlPointRequest.status === 'rejected'"
              class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
              Заявка отклонена
            </div>
          </div>
          <div class="card-info">
            <div class="info-row">
              <div class="info-origin">
                <div class="info-title">Название</div>
                <div class="info-value">{{ parentControlPoint.name }}</div>
              </div>
              <div class="info-changed" v-if="localControlPointRequest.changes.name">
                <div class="info-title">Название (изм.)</div>
                <div class="info-value">{{ localControlPointRequest.changes.name }}</div>
              </div>
            </div>
            <div class="info-row">
              <div class="info-origin">
                <div class="info-title">Тип</div>
                <div class="info-value">{{ controlPointTypes[parentControlPoint.type] }}</div>
              </div>
              <div class="info-changed" v-if="localControlPointRequest.changes.type">
                <div class="info-title">Тип (изм.)</div>
                <div class="info-value">{{ controlPointTypes[localControlPointRequest.changes.type] }}</div>
              </div>
            </div>
            <div class="info-row" >
              <div class="info-origin">
                <div class="info-title">Статус</div>
                <div class="info-value">{{ controlPointStatuses[parentControlPoint.execution_status] }}</div>
              </div>
              <div class="info-changed" v-if="localControlPointRequest.changes.execution_status">
                <div class="info-title">Статус (изм.)</div>
                <div class="info-value">{{ controlPointStatuses[localControlPointRequest.changes.execution_status] }}</div>
              </div>
            </div>
            <div class="info-row">
              <div class="info-origin">
                <div class="info-title">Срок</div>
                <div class="info-value">{{ stringDateToText(parentControlPoint.expired_at) }}</div>
              </div>
              <div class="info-changed" v-if="localControlPointRequest.changes.expired_at">
                <div class="info-title">Срок (изм.)</div>
                <div class="info-value">{{ stringDateToText(localControlPointRequest.changes.expired_at) }}</div>
              </div>
            </div>
            <div class="info-row">
              <div class="info-origin">
                <div class="info-title">Описание</div>
                <div class="info-val">{{ parentControlPoint.description || 'Отсутствует' }}</div>
              </div>
              <div class="info-changed" v-if="localControlPointRequest.changes.description">
                <div class="info-title">Описание (изм.)</div>
                <div class="info-value">{{ localControlPointRequest.changes.description }}</div>
              </div>
            </div>
            <div class="info-row" v-if="permissionsStatus.isControlPointRequestModereateAllowed
              && isCriticalControlPointClosureRequest && localControlPointRequest.status === 'opened'">
              <div class="info-origin">
                <div class="info-title">Комментарий</div>
                <ccs-input class="info-value" type="textarea" placeholder="Введите комментарий"
                  v-model="comment" :modifiers="['auto_expand']"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-discussion">
        <div class="discussion-title">Обсуждение</div>
        <div class="discussion-input">
          <ccs-input class="input-field" type="textarea" placeholder="Новое сообщение"
                     v-model="message.comment"/>
          <div class="input-buttons">
            <div class="ccs-button ccs-6" v-if="!this.message.id"
                 :class="{ 'ccs-button--blight': message.comment.length === 0 }" @click="createNewMessage">
              Отправить
            </div>
            <div class="ccs-button" v-else @click="updateMessage">
              Изменить
            </div>
            <ccs-input class="ccs-6" type="file" label="" v-if="!this.message.id"
                       v-model="message.file" accept="*" :modifiers="['zero_label']" allowFileDelete/>
            <div class="ccs-button ccs-button--light ccs-6" v-if="this.message.id" @click="resetMessage">Отменить</div>
          </div>
        </div>
        <div class="discussion-messages">
          <div class="discussion-message" v-for="attachment in localControlPointRequest.parent_control_point.attachments.data"
               :key="`attachment-${attachment.id}`">
            <div class="message-header">
              <div class="message-sender">{{ attachment.author.full_name }}</div>
            </div>
            <div class="message-content">
              <div class="message-text">
                {{ attachment.comment }}
              </div>
              <div class="message-actions">
                <v-icon v-if="attachment.files && attachment.files.data[0]"
                        class="ccs-icon--primary ccs-icon--hover" name="file" scale="0.9"
                        @click="openFileLink(attachment.files.data[0].url)"/>
                <v-icon v-if="attachment.author.id === user.id || rolesStatus.isAdmin"
                        class="ccs-icon--primary ccs-icon--hover" name="edit"
                        @click="setMessage(attachment)"/>
                <v-icon v-if="attachment.author.id === user.id || rolesStatus.isAdmin"
                        class="ccs-icon--secondary ccs-icon--hover" name="trash" scale="0.9"
                        @click="deleteMessage(attachment.id)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-actions">
        <button class="card-action" v-if="localControlPointRequest.status === 'opened' &&
          permissionsStatus.isControlPointRequestModereateAllowed" @click="acceptControlPointRequest">
          Одобрить
        </button>
        <button class="card-action card-action--delete" v-if="localControlPointRequest.status === 'opened' &&
          permissionsStatus.isControlPointRequestModereateAllowed"
          @click="denyControlPointRequest">
          Отклонить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import DateRender from '@/mixins/DateRender';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'ControlPoint',
  mixins: [DateRender],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      controlPointTypes: {
        critical: 'Критическая',
        functional: 'Функциональная',
      },
      controlPointStatuses: {
        waiting_for_approval: 'Ожидает подтверждения',
        in_progress: 'Выполняется',
        in_closure_process: 'В процессе закрытия',
        completed: 'Завершена'
      },
      localControlPointRequest: {
        id: undefined,
        changes: {},
        parent_control_point: {
          id: 0,
          name: '',
          description: '',
          execution_status: undefined,
          expired_at: new Date(),
          completed_at: new Date(),
          type: 'critical',
        }
      },
      comment: '',
      message: {
        id: null,
        comment: '',
        file: null
      },
    }
  },
  computed: {
    ...mapState('projects', ['controlPointRequest']),
    ...mapGetters('session', ['rolesStatus', 'permissionsStatus']),
    ...mapState('session', ['user']),
    parentControlPoint() {
      return this.localControlPointRequest.parent_control_point;
    },
    isCriticalControlPointClosureRequest() {
      return this.localControlPointRequest.type === 'critical_control_point_closure';
    },
  },
  methods: {
    ...mapMutations('projects', ['switchControlPointRequestModal']),
    ...mapActions('projects', [
      'approveControlPointRequest',
      'rejectControlPointRequest',
      'getControlPointRequestByID',
      'createAttachment',
      'updateAttachment',
      'deleteAttachment',
    ]),
    setLocalControlPointRequest() {
      this.localControlPointRequest = Object.assign({}, this.controlPointRequest);
      this.localControlPointRequest.parent_control_point = Object.assign({}, this.controlPointRequest.parent_control_point);
    },
    async acceptControlPointRequest() {
      try {
        await this.approveControlPointRequest({
          controlPointRequestID: this.controlPointRequest.id,
          comment: this.comment
        });
        this.$toasted.success('Заявка одобрена');
        this.switchControlPointRequestModal();
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async denyControlPointRequest() {
      try {
        await this.rejectControlPointRequest({
          controlPointRequestID: this.controlPointRequest.id,
          comment: this.comment
        });
        this.$toasted.success('Заявка отклонена');
        this.switchControlPointRequestModal();
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    openFileLink(url) {
      window.open(url, '_blank');
    },
    setMessage(message) {
      this.message = Object.assign({}, message);
    },
    resetMessage() {
      this.message = {
        id: null,
        comment: '',
        file: null,
      }
    },
    deleteMessage(messageID) {
      this.$toasted.info("Удалить сообщение?", { action: [{
          text: "Да",
          onClick: (e, toastObject) => {
            this.deleteMessageRequest(messageID);
            toastObject.goAway(0);
          },
        }, {
          text: "Нет",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        }]});
    },
    async deleteMessageRequest(messageID) {
      if (this.message.id === messageID) this.resetMessage();
      try {
        await this.deleteAttachment(messageID);
        this.getControlPointRequestByID(this.localControlPointRequest.id);
        this.$toasted.success('Сообщение удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async createNewMessage() {
      if (this.message.comment.length === 0) return
      try {
        const newAttachment = await this.createAttachment({
          attached_to_type: 'control_points',
          attached_to_id: this.localControlPointRequest.parent_control_point.id,
          comment: this.message.comment,
        });
        if (!!this.message.file) {
          await this.uploadFile({
            file: this.message.file,
            entityID: newAttachment.id,
            entityType: 'attachments',
            fileType: 'document'
          });
        }
        this.getControlPointRequestByID(this.localControlPointRequest.id);
        this.resetMessage();
        this.$toasted.success('Сообщение отправлено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async updateMessage() {
      try {
        await this.updateAttachment({
          id: this.message.id,
          comment: this.message.comment,
        });
        this.getControlPointRequestByID(this.localControlPointRequest.id);
        this.resetMessage();
        this.$toasted.success('Сообщение обновлено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    window.onscroll = function () { window.scrollTo(0, 0); };
  },
  beforeDestroy() {
    window.onscroll = undefined;
  },
  watch: {
    controlPointRequest: {
      immediate: true,
      handler(to) {
        this.setLocalControlPointRequest(to);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.control_point_request {
  z-index: 100;
  position: fixed;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-y: scroll;

  &-overlay {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: #000;
    opacity: 0.8;
  }

  &-card {
    z-index: 101;
    position: relative;
    left: 50%;
    margin-top: 100px;
    margin-bottom: 100px;
    padding: 20px;
    width: 700px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    transform: translateX(-50%);

    .card {

      &-actions {
        margin-top: 20px
      }

      &-action {
        width: 160px;
        height: 31px;
        background: $primary;
        color: #fff;
        border: 1px solid $primary;
        border-radius: 5px;
        font-size: 18px;
        transition: color ease-in-out .2s,
                    border ease-in-out .2s,
                    background ease-in-out .2s;

        &:hover {
          color: $primary;
          background: #fff;
          cursor: pointer;
        }

        &:not(:first-child) {
          margin-left: 10px;
        }

        &--delete {
          background: #fff;
          color: $secondary;
          border: 1px solid $secondary;

          &:hover {
            color: #fff;
            background: $secondary;
            cursor: pointer;
          }

        }

      }


      &-tags {
        margin-bottom: 15px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      }

      &-body {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .body-block {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .card {

            &-info {
              width: 100%;

              .info {

                &-row {
                  margin-top: 25px;
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: stretch;

                  &:first-child {
                    margin-top: 0;
                  }

                  > div:not(:last-child) {
                    margin-bottom: 10px;
                  }

                }

                &-origin, &-changed {
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  font-size: 18;
                }

                &-title {
                  margin-right: 20px;
                  min-width: 100px;
                  max-width: 100px;
                  font-weight: bold;
                }

                &-value {
                  width: 100%;
                  overflow-wrap: anywhere;
                }

              }

            }

          }

        }

      }

      &-discussion {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;

        .discussion {

          &-title {
            margin-bottom: 10px;
            font-size: 16px;
          }

          &-input {

            .input {

              &-buttons {
                margin-top: 10px;
                display: flex;
                justify-content: flex-start;
                align-self: center;

                > div {
                  box-sizing: border-box;

                  &:not(:first-child) {
                    margin-left: 10px;
                  }

                }

              }

            }

          }

          &-messages {
            @include scroll-view(200px);
            margin-top: 20px;
            padding-right: 20px;
          }

          &-message {

            &:not(:first-child) {
              margin-top: 20px;
            }

            .message {

              &-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              &-sender {
                color: $primary;
                font-size: 14px;
              }

              &-content {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
              }

              &-text {
                margin-top: 5px;
                margin-right: 10px;
              }

              &-actions {
                margin-left: auto;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;

                > svg {
                  margin-left: 10px;
                }

              }

            }

          }

        }

      }

    }

  }

}
</style>
